import TextField from '@material-ui/core/TextField'
import styled from 'styled-components'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import Grid from '@material-ui/core/Grid'
import {onChangeStringHandler} from 'lib/dom'
import IconButton from 'lib/ui/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import {OntraportGroup} from 'organization/Event/Services/Apps/Ontraport/Config/Groups'
import {OntraportField} from 'organization/Event/Services/Apps/Ontraport/Config/Fields'
import AutocompleteFields from 'organization/Event/Services/Apps/Ontraport/Config/Fields/AutocompleteFields'

export default function GroupInput(props: {
  group: OntraportGroup
  onChange: (group: OntraportGroup) => void
  onRemove: () => void
}) {
  const {onChange, group, onRemove} = props
  const update = <K extends keyof OntraportGroup>(key: K) => (
    value: OntraportGroup[K],
  ) => {
    const updated = {
      ...group,
      [key]: value,
    }

    onChange(updated)
  }

  const setField = (field: OntraportField | null) => {
    const updated = {
      ...group,
      ...field,
    }

    onChange(updated)
  }

  return (
    <Grid container spacing={2}>
      <Grid item sm={6}>
        <TextField
          label="Key"
          value={group.key}
          fullWidth
          variant="outlined"
          inputProps={{'aria-label': 'group name'}}
          onChange={onChangeStringHandler(update('key'))}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <RemoveButton aria-label="remove group" onClick={onRemove}>
                  <CloseIcon color="error" />
                </RemoveButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item sm={6}>
        <AutocompleteFields
          onChange={setField}
          inputVariant={'outlined'}
          value={{
            field_id: group.field_id || '',
            field_name: group.field_name || '',
            field_type: group.field_type || '',
            field_key: group.field_key || '',
          }}
        />
      </Grid>
    </Grid>
  )
}

const RemoveButton = styled(IconButton)`
  margin-left: ${(props) => props.theme.spacing[2]};
`
